import React from 'react'
import './buttonloader.css'

const ButtonLoader = ({text}) => {
    return (
        <div>
                {text}
        </div>
    )
}

export default ButtonLoader
